module.exports = __webpack_public_path__ + "img/vote.c6e5336e.webp";